import { PhoneCall } from 'legacy/lut/components/shared/PhoneCall'

import { IForm } from 'core-components/classes/models/IForm'

interface IGetContactConnectionInfo {
  contact: IForm
}

export function getContactConnectionInfo({ contact }: IGetContactConnectionInfo) {
  const partnerId = contact.PartnerID

  return [
    {
      label: 'Never Call',
      value: contact.NeverCall,
    },
    {
      label: 'Mobile Phone',
      value: contact.MobilePhone ? (
        <PhoneCall
          value={`${contact.MobilePhone_Prefix || ''}${contact.MobilePhone || ''}`}
          isContactLevel={!!contact.HPD_Contact_GUID}
          guid={contact.HPD_Contact_GUID || contact.HPD_Partner_GUID}
          partnerId={partnerId}
          isColor
        />
      ) : (
        <span>-</span>
      ),
    },
    {
      label: 'Work Phone',
      value: contact.WorkPhone ? (
        <PhoneCall
          value={`${contact.WorkPhone_Prefix || ''}${contact.WorkPhone || ''}`}
          isContactLevel={!!contact.HPD_Contact_GUID}
          guid={contact.HPD_Contact_GUID || contact.HPD_Partner_GUID}
          partnerId={partnerId}
          isColor
        />
      ) : (
        <span>-</span>
      ),
    },
    {
      label: 'Main Phone',
      value: contact.MainPhone ? (
        <PhoneCall
          value={`${contact.MainPhone || ''}`}
          isContactLevel={!!contact.HPD_Contact_GUID}
          guid={contact.HPD_Contact_GUID || contact.HPD_Partner_GUID}
          partnerId={partnerId}
          isColor
        />
      ) : (
        <span>-</span>
      ),
    },
    {
      label: 'Never Email',
      value: contact.NeverEmail,
    },
    {
      label: 'Email',
      value: contact.Email,
    },
    {
      label: 'Email Office',
      value: contact.EmailCompany,
    },
    {
      label: 'Last Update',
      value: contact.LastContactUpdateDate,
    },
  ]
}
